"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlob = void 0;
const Blob_1 = require("./Blob");
const isBlob = (value) => value instanceof Blob_1.Blob;
exports.isBlob = isBlob;
